import React from "react";
import { ChevronDown } from "lucide-react";
import { useEventList, useEventSlug } from "@/lib/eventContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export function EventPicker() {
  const { slug, setSlug } = useEventSlug();
  const { items } = useEventList();
  const active = items.find((e) => e.slug === slug) || { name: "Members Day 2026", slug };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="event-picker-btn" className="btn-ghost !py-2 flex items-center gap-2">
          <span className="mono-label" style={{ color: "var(--taupe)" }}>EVENT</span>
          <span className="text-sm truncate max-w-[220px]">{active.name}</span>
          <ChevronDown size={12} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[280px]">
        <DropdownMenuLabel>Switch active event</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 && (
          <DropdownMenuItem disabled className="opacity-60">No events yet</DropdownMenuItem>
        )}
        {items.map((e) => (
          <DropdownMenuItem
            key={e.slug}
            data-testid={`event-option-${e.slug}`}
            onClick={() => { setSlug(e.slug); window.location.reload(); }}
            className="flex flex-col items-start"
          >
            <span className="text-sm">{e.name}</span>
            <span className="mono-label" style={{ color: "var(--taupe)" }}>{e.slug} · {e.status || "—"}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
